import { ContentTypeEnum, CONTENT_TYPES_WITH_DATE } from 'constants-content';

export default function hasDates(availableTypes: ContentTypeEnum[]) {
  return CONTENT_TYPES_WITH_DATE.some(type => availableTypes.includes(type));
}
